import { render, staticRenderFns } from "./Atention.vue?vue&type=template&id=868d9abe&scoped=true&lang=pug&"
import script from "./Atention.vue?vue&type=script&lang=js&"
export * from "./Atention.vue?vue&type=script&lang=js&"
import style0 from "./Atention.vue?vue&type=style&index=0&id=868d9abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868d9abe",
  null
  
)

export default component.exports